/**
 * The Seep orb, the SEEP AI voice assistant's mark. Used wherever the CRM
 * points at SEEP (the settings card, the SEEP settings page) so it reads as
 * the same product customers meet on the website.
 */
export default function SeepLogo({ size = 40, framed = false, alt = "SEEP AI" }) {
  const src = `${process.env.PUBLIC_URL || ""}/seep/seep-orb.png`;
  return (
    <img
      src={src}
      alt={alt}
      width={size}
      height={size}
      style={{
        width: size,
        height: size,
        objectFit: "contain",
        borderRadius: "50%",
        flexShrink: 0,
        ...(framed ? { background: "#fff", padding: Math.round(size * 0.08), boxShadow: "0 2px 6px rgba(9,36,87,.18)" } : {}),
      }}
    />
  );
}
